<template>
	<div>
		<div class="login_bg"></div>
		<b-overlay id="overlay-background" :show="loading" opacity="0.6" style="width: 100%;" spinner-variant="primary">
			<b-form id="reg" @submit.prevent="register">
				<div class="auth-wrapper auth-v1 px-2">
					<div class="auth-inner py-2">
						<b-card class="mb-0">
							<div class="title">注册梦幻云</div>
							<b-tabs align="center" class="mt-2">
								<b-tab active>
									<template #title>
										<feather-icon icon="HomeIcon" />
										<span>公司信息</span>
									</template>
									<b-card-text>
										<b-form-group label-for="name" label="姓名">
											<b-form-input id="name" v-model="data.name" name="name" placeholder="请输入姓名"
												autofocus />
										</b-form-group>
										<b-form-group label-for="company_name" label="公司名称">
											<b-form-input id="company_name" v-model="data.company_name"
												name="company_name" placeholder="请输入公司名称" />
										</b-form-group>
										<b-form-group label-for="industry_type" label="行业类型">
											<v-select :options="industry_type_options" v-model="data.industry_type"
												:reduce="(industry_type) => industry_type.id" label="text"
												placeholder="请选择行业类型" />
										</b-form-group>
										<b-form-group label-for="staff_size" label="公司规模">
											<v-select :options="staff_size_options" v-model="data.staff_size"
												:reduce="(staff_size) => staff_size.id" label="text"
												placeholder="请选择公司规模" />
										</b-form-group>
										<b-form-group label-for="area" label="公司地址">
											<b-form-input id="area" v-model="data.area" name="area"
												placeholder="请输入公司地址" />
										</b-form-group>
									</b-card-text>
								</b-tab>
								<b-tab>
									<template #title>
										<feather-icon icon="UserIcon" />
										<span>账号信息</span>
									</template>
									<b-card-text>
										<b-form-group label-for="account" label="账号">
											<b-form-input id="account" v-model="data.account" name="account"
												placeholder="请输入账号" />
										</b-form-group>
										<b-form-group>
											<div class="d-flex justify-content-between">
												<label for="password">密码</label>
											</div>
											<b-input-group class="input-group-merge">
												<b-form-input id="password" v-model="data.password"
													:type="passwordFieldType" class="form-control-merge" name="password"
													placeholder="请输入密码" />
												<b-input-group-append is-text>
													<feather-icon class="cursor-pointer" :icon="passwordToggleIcon"
														@click="togglePasswordVisibility" />
												</b-input-group-append>
											</b-input-group>
										</b-form-group>
										<b-form-group>
											<div class="d-flex justify-content-between">
												<label for="password">确认密码</label>
											</div>
											<b-input-group class="input-group-merge">
												<b-form-input id="password2" v-model="data.password2"
													:type="passwordFieldType" class="form-control-merge"
													name="password2" placeholder="请再次输入密码" />
												<b-input-group-append is-text>
													<feather-icon class="cursor-pointer" :icon="passwordToggleIcon"
														@click="togglePasswordVisibility" />
												</b-input-group-append>
											</b-input-group>
										</b-form-group>
										<b-form-group label-for="phone" label="手机号">
											<b-form-input id="phone" v-model="data.phone" name="phone"
												placeholder="请输入手机号" />
										</b-form-group>
										<b-form-group label-for="email" label="邮箱">
											<b-form-input id="email" v-model="data.email" name="email"
												placeholder="请输入邮箱" />
										</b-form-group>
									</b-card-text>
								</b-tab>
							</b-tabs>
							<!-- form -->
							<validation-observer ref="loginForm" #default="{invalid}">
								<!-- submit button -->
								<b-button variant="primary" block :disabled="invalid" type="submit" class="mt-2 mb-1">
									注册
								</b-button>
							</validation-observer>
						</b-card>
						<!-- /Login v1 -->
					</div>
				</div>
			</b-form>
		</b-overlay>
	</div>
</template>

<script>
	import {
		ValidationProvider,
		ValidationObserver
	} from "vee-validate";
	import {
		BButton,
		BForm,
		BFormInput,
		BFormGroup,
		BCard,
		BLink,
		BCardTitle,
		BCardText,
		BInputGroup,
		BInputGroupAppend,
		BFormCheckbox,
		BTabs,
		BTab,
		BOverlay,
	} from "bootstrap-vue";
	import VuexyLogo from "@core/layouts/components/Logo.vue";
	import {
		required,
		email
	} from "@validations";
	import {
		togglePasswordVisibility
	} from "@core/mixins/ui/forms";
	import vSelect from "vue-select";

	export default {
		components: {
			// BSV
			BButton,
			BForm,
			BFormInput,
			BFormGroup,
			BCard,
			BCardTitle,
			BLink,
			VuexyLogo,
			BCardText,
			BInputGroup,
			BInputGroupAppend,
			BFormCheckbox,
			ValidationProvider,
			ValidationObserver,
			BCardText,
			BTabs,
			BTab,
			vSelect,
			BOverlay,
		},
		mixins: [togglePasswordVisibility],
		data() {
			return {
				loading: false,
				data: {},
				industry_type_options: this.$dic.industry_type,
				staff_size_options: this.$dic.staff_size,
			};
		},
		computed: {
			passwordToggleIcon() {
				return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
			},
		},

		mounted() {
			var openid = this.$route?.query?.openid;
			if (openid) {
				this.data.mhy_open_id = openid;
			}
		},
		methods: {
			register() {
				this.loading = true;
				this.$http
					.post("/Account/Register", this.data)
					.then((u) => {
						this.loading = false;
						this.data = {};
						this.$successAlert("注册成功，请登录！");
						this.$router.replace({
							name: "Login",
						});
					})
					.catch((u) => {
						this.loading = false;
					});
			},
		},
	};
</script>

<style lang="scss">
	@import "@core/scss/vue/pages/page-auth.scss";

	.login_bg {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: url("../assets/images/bg2.jpg") no-repeat;
		background-size: cover;
		z-index: 0;
	}

	#reg .form-group {
		margin-bottom: 0.5rem !important;
	}

	.title {
		position: absolute;
		top: 8px;
		left: 10px;
		font-size: 14px;
	}

	.auth-wrapper.auth-v1 {
		transform: translateY(-3rem);
	}

	.v-select {
		height: 2.75rem !important;
	}
</style>